import { render, staticRenderFns } from "./SubList.vue?vue&type=template&id=0c813a02&scoped=true&"
import script from "./SubList.vue?vue&type=script&lang=ts&"
export * from "./SubList.vue?vue&type=script&lang=ts&"
import style0 from "./SubList.vue?vue&type=style&index=0&id=0c813a02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c813a02",
  null
  
)

export default component.exports